module.exports = __webpack_public_path__ + "static/media/aws.1d786e39.png";